import { Markdown, MarkdownSize } from '@vtblife/react-markdown';
import { Button } from '@vtblife/uikit';
import React from 'react';
import cn from 'classnames';
import styles from './info-step.module.css';
export function InfoStep(props) {
    const { buttons = [], subtitle, title, imageSrc, mobileImageSrc, layout = '6c', imageSize, variant } = props;
    return (React.createElement("div", { className: cn(styles.container, styles[`layout-${layout}`], styles[`image-size-${imageSize}`], styles[`variant-${variant}`], {
            [styles.hasImage]: !!imageSrc,
        }) },
        React.createElement("div", { className: styles.content },
            imageSrc && (React.createElement("picture", { className: styles.imageWrap },
                mobileImageSrc && React.createElement("source", { srcSet: mobileImageSrc, media: `(max-width: 768px)` }),
                React.createElement("img", { src: imageSrc, alt: '' }))),
            title && (React.createElement("div", { className: styles.title },
                React.createElement(Markdown, { startHeader: 2, source: title, minimalHeadingStyleLevel: 2, sizeVariant: MarkdownSize.Quiz }))),
            subtitle && React.createElement("div", { className: styles.subtitle }, subtitle)),
        buttons.length > 0 && (React.createElement("div", { className: styles.buttons }, buttons.map((button, i) => {
            return (React.createElement("div", { key: i, className: styles.button },
                React.createElement(Button, { variant: button.variant, onClick: button.onClick, fullWidth: true, size: "l", href: button.url }, button.text)));
        })))));
}
//# sourceMappingURL=info-step.js.map